import React, {useContext} from "react";
import FormStyling from "../../../../components/form/form-component";
import MFA from "./AuthItems/MFA";
import { AppConfig } from "../../../../context/context";
import { PINAUTHCONTROL_FEATURE } from "../../../../utils/constants";

type FormProps = {
  handleChange: any;
  availableSettings: any;
  pinData?: { pin: boolean | string; uniqueId: string, pinLength: number | string };
  EntraId?: { id: string; status: any };
  MFAInfo: { typeMFA: string; enableMFA: boolean};
};

const Form = (props: FormProps) => {
  const { handleChange, availableSettings, pinData , EntraId, MFAInfo } = props;
  const { availableFeatures } = useContext(AppConfig);
  const oidcFeature = availableFeatures.find((feature) => feature === "oidc");
  const pinFeature = availableFeatures.includes(PINAUTHCONTROL_FEATURE);

  return (
    <>
      <FormStyling>
        {/*pinFeature && availableSettings && <Pin handleChange={handleChange} pinData={pinData as any} />*/}
        {/*will toggle when feature flag is available, Sang will create a task */}
        {/* {oidcFeature && ( */}
        {/* <Entra EntraId={EntraId} handleChange={handleChange} /> */}
        {/* )} */}
        <MFA handleChange={handleChange} MFAInfo={MFAInfo} />
      </FormStyling>
    </>
  );
};

export default Form;
